module.exports = __webpack_public_path__ + "assets/img/4_115.d98e0ad6.jpg";